module.exports = __webpack_public_path__ + "img/cc.3fe92409.svg";